import Meeting from '../animations/spritesheets/meeting_anim.png';

import speakerHeadExpressionForward from '../animations/spritesheets/speaker/speaker_head_expressions_face_front.png';
import speakerHeadExpressionLeft from '../animations/spritesheets/speaker/speaker_head_expressions_face_left.png';
import speakerHeadExpressionLeftUp from '../animations/spritesheets/speaker/speaker_head_expressions_face_left_up.png';
import speakerHeadExpressionRight from '../animations/spritesheets/speaker/speaker_head_expressions_face_right.png';
import speakerHeadExpressionRightUp from '../animations/spritesheets/speaker/speaker_head_expressions_face_right_up.png';

import speakerBodyTap from '../animations/spritesheets/speaker/speaker_body_tap.png';
import speakerBodyLeft from '../animations/spritesheets/speaker/speaker_body_point_left.png';
import speakerBodyForward from '../animations/spritesheets/speaker/speaker_body_point.png';
import speakerBodyRight from '../animations/spritesheets/speaker/speaker_body_point_right.png';

import femaleMp from '../animations/spritesheets/speaker/mp_female.png';
import maleMp from '../animations/spritesheets/speaker/mp_male.png';

import Journalist1 from '../animations/spritesheets/press/person1.png';
import Journalist2 from '../animations/spritesheets/press/person2.png';
import Journalist3 from '../animations/spritesheets/press/person3.png';
import Journalist4 from '../animations/spritesheets/press/person4.png';
import Journalist5 from '../animations/spritesheets/press/person5.png';
import Journalist6 from '../animations/spritesheets/press/person6.png';
import Journalist7 from '../animations/spritesheets/press/person7.png';
import Journalist8 from '../animations/spritesheets/press/person8.png';
import Journalist9 from '../animations/spritesheets/press/person9.png';
import Chair from '../animations/spritesheets/press/game_press_chair.png';

export const allAnimations = [
    Meeting,
    speakerHeadExpressionForward,
    speakerHeadExpressionLeft,
    speakerHeadExpressionLeftUp,
    speakerHeadExpressionRight,
    speakerHeadExpressionRightUp,
    speakerBodyTap,
    speakerBodyLeft,
    speakerBodyForward,
    speakerBodyRight,
    femaleMp,
    maleMp,
    Journalist1,
    Journalist2,
    Journalist3,
    Journalist4,
    Journalist5,
    Journalist6,
    Journalist7,
    Journalist8,
    Journalist9,
    Chair,
];
